module.exports = __webpack_public_path__ + "media/images/right_show_sidebar/clock-06dedbb4b761aba9d1ab9b53bcd85489.svg";